<template>
  <div>
    <breadcrumb/>
    <br />
    <v-card>
      <surveys-list :surveys="getSurveys"></surveys-list>
      <h3 display-2 pa-20 class="text-xs-center" v-if="getSurveys.length <= 0">No hay encuestas</h3>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import SurveysList from "@/components/Surveys/SurveysList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    SurveysList,
    Breadcrumb
  },
  mounted() {
    window.scrollTo(0, 0);
    this.fetchSurveys();
  },
  methods: {
    ...mapActions("surveys", ["fetchSurveys"])
  },
  computed: {
    ...mapState("user", ["current_user"]),
    ...mapGetters("surveys", ["getSurveys"])
  }
};
</script>
